import { ImageContainer, ImageStyle, ImageTypography } from './table-pics.styles';
import ErrorPic from '../../../images/error.png';

export function ErrorPage() {
  return (
    <ImageContainer id='error-div'>
      <ImageStyle>
        <img
          id='error-img'
          src={ErrorPic}
          alt='no products were found'
          width='100%'
          height='100%'
        />
      </ImageStyle>
      <ImageTypography>Oppps, Something went wrong..</ImageTypography>
    </ImageContainer>
  );
}
